import {useLinkedIn} from "react-linkedin-login-oauth2";
import {
  Box, Button, Chip, Divider, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography
} from "@mui/material";
import {useEffect, useState} from "react";
import {
  deleteIntegration,
  getIntegration, saveWordpressIntegration
} from "../../services/IntegrationService";
import LinkIcon from '@mui/icons-material/Link';
import LinkOffIcon from '@mui/icons-material/LinkOff';
import LoginIcon from '@mui/icons-material/Login';
import LogoutIcon from '@mui/icons-material/Logout';

const CompanyIntegration = ({company}) => {
  const [integrations, setIntegrations] = useState([])
  const [reload, setReload] = useState(false);
  const [orgId, setOrgId] = useState(null)
  const [integratingList, setIntegratingListList] = useState(["LINKEDIN", "WORDPRESS"]);

  const base64 = require('base-64');

  const { linkedInLogin } = useLinkedIn({
    clientId: '77zh6n99phm6z5',
    scope: 'r_basicprofile w_member_social w_organization_social',
    redirectUri: `${window.location.origin}/app/linkdin?data=${base64.encode(JSON.stringify({companyId: company.id, orgId: orgId}))}`,
    onSuccess: (code) => {
      setReload(prv => !prv)
    },
    onError: (error) => {
      setReload(prv => !prv)
    },
  });

  useEffect(() => {
    getIntegration(company.id)
        .then(res => setIntegrations(res.data))
  }, [reload]);

  const logout = (type) =>{
    deleteIntegration(company.id, type)
        .then(() => setReload(prv => !prv))
  }

  const getStatusChip = (status) => {
    const isConnected = status === 'CONNECTED';
    return (
      <Chip
        size="small"
        icon={isConnected ? <LinkIcon /> : <LinkOffIcon />}
        label={status || "NOT CONNECTED"}
        color={isConnected ? "success" : "default"}
        variant={isConnected ? "filled" : "outlined"}
      />
    );
  };

  const getNewWordPressRow = () => {
    return (
      <TableRow>
        <TableCell sx={{ verticalAlign: "top", pt: 3 }}>
          <Typography variant="body2" fontWeight={600}>WordPress</Typography>
        </TableCell>
        <TableCell sx={{ verticalAlign: "top", pt: 3 }}>
          {getStatusChip(null)}
        </TableCell>
        <TableCell>
          <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5, py: 1 }}>
            {/* Connection Settings */}
            <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 600, textTransform: "uppercase", mt: 1 }}>
              Connection Settings
            </Typography>
            <Box sx={{ display: "flex", gap: 2 }}>
              <TextField
                size="small"
                sx={{ flex: 1 }}
                id="userName"
                name="userName"
                label="Username"
                type="text"
                variant="outlined"
              />
              <TextField
                size="small"
                sx={{ flex: 1 }}
                id="password"
                name="password"
                label="Password"
                type="password"
                variant="outlined"
              />
            </Box>
            <Box sx={{ display: "flex", gap: 2 }}>
              <TextField
                size="small"
                sx={{ flex: 1 }}
                id="siteUrl"
                name="siteUrl"
                label="Site URL"
                type="text"
                variant="outlined"
              />
              <TextField
                size="small"
                sx={{ flex: 1 }}
                id="wordpressUrl"
                name="wordpressUrl"
                label="WordPress API URL"
                type="text"
                variant="outlined"
                defaultValue="/wp-json/wp/v2/posts"
              />
              <TextField
                size="small"
                sx={{ width: 120 }}
                id="categoryId"
                name="categoryId"
                label="Category ID"
                type="number"
                variant="outlined"
              />
            </Box>

            {/* Image Settings #1 */}
            <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 600, textTransform: "uppercase", mt: 2 }}>
              Image Settings #1
            </Typography>
            <Box sx={{ display: "flex", gap: 2 }}>
              <TextField
                size="small"
                sx={{ flex: 1 }}
                id="firstImage"
                name="firstImage"
                label="Image URL"
                type="text"
                variant="outlined"
              />
              <TextField
                size="small"
                sx={{ width: 120 }}
                id="paragraphNumberOne"
                name="paragraphNumberOne"
                label="Paragraph #"
                type="text"
                variant="outlined"
              />
              <TextField
                size="small"
                sx={{ flex: 1 }}
                id="imageUrlOne"
                name="imageUrlOne"
                label="Image Link URL"
                type="text"
                variant="outlined"
              />
            </Box>

            {/* Image Settings #2 */}
            <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 600, textTransform: "uppercase", mt: 2 }}>
              Image Settings #2
            </Typography>
            <Box sx={{ display: "flex", gap: 2 }}>
              <TextField
                size="small"
                sx={{ flex: 1 }}
                id="secondImage"
                name="secondImage"
                label="Image URL"
                type="text"
                variant="outlined"
              />
              <TextField
                size="small"
                sx={{ width: 120 }}
                id="paragraphNumberTwo"
                name="paragraphNumberTwo"
                label="Paragraph #"
                type="text"
                variant="outlined"
              />
              <TextField
                size="small"
                sx={{ flex: 1 }}
                id="imageUrlTwo"
                name="imageUrlTwo"
                label="Image Link URL"
                type="text"
                variant="outlined"
              />
            </Box>

            {/* Video Settings */}
            <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 600, textTransform: "uppercase", mt: 2 }}>
              Video Settings (Optional)
            </Typography>
            <Box sx={{ display: "flex", gap: 2 }}>
              <TextField
                size="small"
                sx={{ flex: 1 }}
                id="video"
                name="video"
                label="Video URL"
                type="text"
                variant="outlined"
              />
              <TextField
                size="small"
                sx={{ width: 120 }}
                id="video_paragraph"
                name="video_paragraph"
                label="Paragraph #"
                type="text"
                variant="outlined"
              />
            </Box>
          </Box>
        </TableCell>
        <TableCell align="right" sx={{ verticalAlign: "top", pt: 3 }}>
          <Button type="submit" variant="contained" size="small" startIcon={<LoginIcon />}>
            Connect
          </Button>
        </TableCell>
      </TableRow>
    );
  }

  const getEditWordPressRow = (integrationValue) => {
    const props = integrationValue.properties;

    const InfoRow = ({ label, value }) => (
      <Box sx={{ display: "flex", py: 0.5 }}>
        <Typography variant="body2" sx={{ fontWeight: 600, minWidth: 150, color: "text.secondary" }}>{label}:</Typography>
        <Typography variant="body2" sx={{ wordBreak: "break-all" }}>{value || "-"}</Typography>
      </Box>
    );

    return (
      <TableRow>
        <TableCell sx={{ verticalAlign: "top", pt: 3 }}>
          <Typography variant="body2" fontWeight={600}>WordPress</Typography>
        </TableCell>
        <TableCell sx={{ verticalAlign: "top", pt: 3 }}>
          {getStatusChip(integrationValue.status)}
        </TableCell>
        <TableCell>
          <Box sx={{ py: 1 }}>
            {/* Connection Info */}
            <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 600, textTransform: "uppercase" }}>
              Connection Info
            </Typography>
            <Box sx={{ mt: 1, mb: 2 }}>
              <InfoRow label="Site URL" value={props.SITE_URL} />
              <InfoRow label="WordPress URL" value={props.WORDPRESS_URL} />
              <InfoRow label="Category ID" value={props.CATEGORY_ID} />
            </Box>

            {/* Image #1 Info */}
            <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 600, textTransform: "uppercase" }}>
              Image #1
            </Typography>
            <Box sx={{ mt: 1, mb: 2 }}>
              <InfoRow label="Image URL" value={props.IMAGE_URL_1} />
              <InfoRow label="Paragraph #" value={props.IMAGE_PARAGRAPH_1} />
              <InfoRow label="Link URL" value={props.IMAGE_LINK_URL_1} />
            </Box>

            {/* Image #2 Info */}
            <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 600, textTransform: "uppercase" }}>
              Image #2
            </Typography>
            <Box sx={{ mt: 1, mb: 2 }}>
              <InfoRow label="Image URL" value={props.IMAGE_URL_2} />
              <InfoRow label="Paragraph #" value={props.IMAGE_PARAGRAPH_2} />
              <InfoRow label="Link URL" value={props.IMAGE_LINK_URL_2} />
            </Box>

            {/* Video Info */}
            <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 600, textTransform: "uppercase" }}>
              Video
            </Typography>
            <Box sx={{ mt: 1 }}>
              <InfoRow label="Video URL" value={props.VIDEO_URL} />
              <InfoRow label="Paragraph #" value={props.VIDEO_PARAGRAPH} />
            </Box>
          </Box>
        </TableCell>
        <TableCell align="right" sx={{ verticalAlign: "top", pt: 3 }}>
          <Button onClick={() => logout("WORDPRESS")} variant="outlined" size="small" color="error" startIcon={<LogoutIcon />}>
            Disconnect
          </Button>
        </TableCell>
      </TableRow>
    );
  }

  const getLinkedInRow = () => {
    const integrationValue = integrations.find(item => item.type === 'LINKEDIN');
    const isConnected = integrationValue?.status === 'CONNECTED';

    return (
      <TableRow>
        <TableCell>
          <Typography variant="body2" fontWeight={600}>LinkedIn</Typography>
        </TableCell>
        <TableCell>
          {getStatusChip(integrationValue?.status)}
        </TableCell>
        <TableCell>
          {!isConnected ? (
            <TextField
              size="small"
              value={orgId || ''}
              onChange={(e) => setOrgId(e.target.value)}
              sx={{ width: 200 }}
              id="orgId"
              name="orgId"
              label="Organization ID"
              type="text"
              variant="outlined"
            />
          ) : (
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <Typography variant="body2" color="text.secondary">Org ID:</Typography>
              <Typography variant="body2" fontWeight={500}>{integrationValue?.properties.ORGID}</Typography>
            </Box>
          )}
        </TableCell>
        <TableCell align="right">
          {isConnected ? (
            <Button onClick={() => logout('LINKEDIN')} variant="outlined" size="small" color="error" startIcon={<LogoutIcon />}>
              Disconnect
            </Button>
          ) : (
            <Button onClick={linkedInLogin} variant="contained" size="small" startIcon={<LoginIcon />}>
              Connect
            </Button>
          )}
        </TableCell>
      </TableRow>
    );
  }

  const getIntegrationRow = (integration) => {
    if (integration === 'LINKEDIN') {
      return getLinkedInRow();
    } else if (integration === 'WORDPRESS') {
      const integrationValue = integrations.find(item => item.type === integration);
      return integrationValue ? getEditWordPressRow(integrationValue) : getNewWordPressRow();
    }
  }

  const handleWordpressLogin = (event) => {
    event.preventDefault();
    const formData = new FormData(event.currentTarget);
    const formJson = Object.fromEntries(formData.entries());

    saveWordpressIntegration({
      companyId: company.id,
      userName: formJson.userName,
      password: formJson.password,
      siteUrl: formJson.siteUrl,
      wordpressUrl: formJson.wordpressUrl,
      categoryId: formJson.categoryId,
      imageUrl1: formJson.firstImage,
      imageLinkUrl1: formJson.imageUrlOne,
      imageParagraphNumber1: formJson.paragraphNumberOne,
      imageUrl2: formJson.secondImage,
      imageLinkUrl2: formJson.imageUrlTwo,
      imageParagraphNumber2: formJson.paragraphNumberTwo,
      videoUrl: formJson.video,
      videoParagraph: formJson.video_paragraph
    }).then(r => setReload(prv => !prv))
  }

  return (
    <Paper sx={{ mt: 3, p: 3 }} elevation={1} component="form" onSubmit={handleWordpressLogin}>
      <Typography variant="subtitle2" color="text.secondary" sx={{ mb: 2, fontWeight: 600, fontSize: "0.75rem", textTransform: "uppercase" }}>
        Connected Services
      </Typography>

      <TableContainer>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell sx={{ fontWeight: 600, width: 120 }}>Service</TableCell>
              <TableCell sx={{ fontWeight: 600, width: 150 }}>Status</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>Configuration</TableCell>
              <TableCell align="right" sx={{ fontWeight: 600, width: 130 }}>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {integratingList.map((integration, index) => (
              <>{getIntegrationRow(integration)}</>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
}

export default CompanyIntegration;
